export const FAILOVER_MIN_ERRORS = 3;
export const FAILOVER_MIN_DURATION_MS = 10000;

const RELEVANT_DETAILS = new Set([
  "manifestLoadError",
  "manifestLoadTimeOut",
  "manifestParsingError",
  "levelLoadError",
  "levelLoadTimeOut",
]);

export function isRelevantHlsError(data) {
  return data?.type === "networkError" || RELEVANT_DETAILS.has(data?.details);
}

export function recordHlsError(state, data, now = Date.now()) {
  if (!isRelevantHlsError(data)) return { ...state, shouldFailover: false };
  const firstErrorAt = state.firstErrorAt ?? now;
  const errorCount = state.errorCount + 1;
  return {
    firstErrorAt,
    errorCount,
    shouldFailover:
      errorCount >= FAILOVER_MIN_ERRORS && now - firstErrorAt >= FAILOVER_MIN_DURATION_MS,
  };
}

export function resetHlsErrors() {
  return { firstErrorAt: null, errorCount: 0, shouldFailover: false };
}

export function failoverDelayMs(state, now = Date.now()) {
  if (state.errorCount < FAILOVER_MIN_ERRORS || state.firstErrorAt === null) return null;
  return Math.max(0, FAILOVER_MIN_DURATION_MS - (now - state.firstErrorAt));
}

export async function findHealthyBackup(sources, failedIndexes, verify) {
  for (let index = 1; index < sources.length; index += 1) {
    if (failedIndexes.has(index)) continue;
    try {
      const result = await verify(index);
      if (result?.healthy && result?.source?.delivery_mode === "direct_hls") return index;
    } catch (_error) {
      // A failed verification is equivalent to an unhealthy candidate.
    }
    failedIndexes.add(index);
  }
  return null;
}
